import cx from 'classnames'

export function TableColumnHeader({
  children,
  colSpan,
  className,
  align = 'left'
}: {
  children?: React.ReactNode
  colSpan?: number
  className?: string
  align?: 'left' | 'right' | 'center'
}) {
  return (
    <th className={cx('table-column-header', className)} colSpan={colSpan} align={align}>
      {children}
    </th>
  )
}

export function TableColumnGroupHeader({
  children,
  className,
  colSpan
}: {
  children: React.ReactNode
  className?: string
  colSpan?: number
}) {
  return (
    <th className={cx('table-column-header table-column-group-header', className)} colSpan={colSpan}>
      {children}
      <hr className="table-column-group-divider" />
    </th>
  )
}
